<template>
  <modal
    class="edit-card-modal"
    name="EditCardModal"
    :maxWidth="550"
    :adaptive="true"
    :height="isMobileDevice ? '100%' : '80%'"
    draggable=".edit-modal-window-title"
    @opened="opened"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div class="modal-edit-card-container">
      <div v-if="!cardLoaded" class="card-loaded-spinner-wrapper">
        <Spinner size="64" />
      </div>
      <EditCard v-show="cardLoaded" :card="card" @cancel="cancel()" />
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import cache from "@/store/cache.js";
import EditCard from "@/components/edit/card/EditCard.vue";

import urlManager from "../common/urls";
import utils from "@/utils";
export default {
  name: "EditCardModal",
  components: { EditCard },
  computed: {
    ...mapGetters(["isMobileDevice", "loaded"]),
    cardLoaded() {
      return !!this.card;
    },
    card() {
      return this.params.card;
    }
  },
  methods: {
    cancel() {
      this.$modal.hide("EditCardModal");
    },
    beforeClose(event) {
      if (this.$store.state.dialogs.confirmation) {
        event.stop();
        return;
      }

      this.params.card = null;
      this.params.cardId = null;
      this.params.boardId = null;
      this.params.inBoardId = null;

      urlManager.toCurrentBoard();
    },
    beforeOpen(event) {
      this.params.card = event.params.card;
      this.params.cardId = parseInt(event.params.cardId);
      this.params.boardId = parseInt(event.params.boardId);
      this.params.inBoardId = parseInt(event.params.inBoardId);
    },
    async opened() {
      await this.$store.dispatch("boards/activateBoard", this.params.boardId);
      if (utils.isDebug()) {
        console.log("url in opened after board was activated", this.$router.currentRoute.path);
      }
      if (this.params.card) {
        return;
      }

      const inBoardId = this.params.inBoardId;
      if (inBoardId) {
        this.params.card = await cache.tryGet(() => cache.cards.byInBoardId(this.params.boardId, inBoardId), 10000);
      } else {
        const id = this.params.cardId;
        this.params.card = await cache.tryGet(() => cache.cards.byId(id), 10000);
      }

      if (!this.params.card) {
        this.cancel();

        this.$snotify.error("Не удалось загрузить карточку", {
          timeout: 1000,
          showProgressBar: false
        });
      }
    }
  },
  data() {
    return {
      params: {
        card: null,
        cardId: 0,
        boardId: 0,
        inBoardId: 0
      }
    };
  }
};
</script>

<style lang="postcss">
.edit-card-modal {
  height: 100%;

  .modal-edit-card-container {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    width: 100%;

    & > * {
      /* hack because of border! */
      height: calc(100% - 2px);
    }

    .card-loaded-spinner-wrapper {
      padding-top: calc(50% + 32px);
    }
  }
}
</style>
